import { render } from "./modalAtendimentos.vue?vue&type=template&id=0bb220ea&scoped=true&ts=true"
import script from "./modalAtendimentos.vue?vue&type=script&lang=ts"
export * from "./modalAtendimentos.vue?vue&type=script&lang=ts"

import "./modalAtendimentos.vue?vue&type=style&index=0&id=0bb220ea&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb220ea"]])

export default __exports__